var _metadata, _defs, _sodipodiNamedview;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDiscover(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlnsDc: "http://purl.org/dc/elements/1.1/",
    xmlnsCc: "http://creativecommons.org/ns#",
    xmlnsRdf: "http://www.w3.org/1999/02/22-rdf-syntax-ns#",
    xmlnsSvg: "http://www.w3.org/2000/svg",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlnsDodipodi: "http://sodipodi.sourceforge.net/DTD/sodipodi-0.dtd",
    xmlnsInkscape: "http://www.inkscape.org/namespaces/inkscape",
    id: "svg2",
    xmlSpace: "preserve",
    width: 122,
    height: 86,
    viewBox: "0 0 122 86",
    sodipodiDocname: "09-12-21_04_20_DGN_AcceptanceMark_FC_Hrz_RGB.eps",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _metadata || (_metadata = /*#__PURE__*/React.createElement("metadata", {
    id: "metadata8"
  }, /*#__PURE__*/React.createElement("rdfRDF", null, /*#__PURE__*/React.createElement("ccWork", {
    rdfAbout: ""
  }, /*#__PURE__*/React.createElement("dcFormat", null, "image/svg+xml"), /*#__PURE__*/React.createElement("dcType", {
    rdfResource: "http://purl.org/dc/dcmitype/StillImage"
  }))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", {
    id: "defs6"
  }, /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "clipPath40"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,0 H 1157 V 1546 H 0 Z",
    id: "path38"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "clipPath46"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 866.102,1255.11 c 0,-155.35 -125.934,-281.278 -281.282,-281.278 H 30 c -11.0273,0 -20,8.969 -20,20 v 522.558 c 0,11.03 8.9727,20 20,20 h 554.82 c 155.348,0 281.282,-125.93 281.282,-281.28 v 0 m 14.82,291.28 H 30 c -16.5703,0 -30,-13.43 -30,-30 L 0,993.832 c 0,-16.57 13.4297,-30 30,-30 h 850.922 c 16.566,0 30,13.43 30,30 v 522.558 c 0,16.57 -13.434,30 -30,30",
    id: "path44"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "clipPath52"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 996.18,1255.11 c 0,-298.434 -241.934,-540.364 -540.367,-540.364 -298.434,0 -540.3638,241.93 -540.3638,540.364 0,298.44 241.9298,540.37 540.3638,540.37 298.433,0 540.367,-241.93 540.367,-540.37",
    id: "path50"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "clipPath230"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 450.539,1190.98 c -36.18,0 -65.519,29.34 -65.519,65.52 0,0 0,0 0,0.09 0,18 7.289,34.38 19.082,46.17 0,0.09 0.089,0.09 0.089,0.18 0.09,0 0.09,0.09 0.18,0.09 11.789,11.79 28.168,19.08 46.168,19.08 0.09,0 0.09,0 0.09,0 36.18,0 65.519,-29.34 65.519,-65.52 0,-0.09 0,-0.09 0,-0.09 0,-18 -7.289,-34.29 -19.078,-46.17 0,-0.09 -0.09,-0.09 -0.09,-0.18 -0.089,0 -0.089,-0.09 -0.179,-0.09 -11.879,-11.79 -28.172,-19.08 -46.172,-19.08 0,0 0,0 -0.09,0",
    clipRule: "evenodd",
    id: "path228"
  })))), _sodipodiNamedview || (_sodipodiNamedview = /*#__PURE__*/React.createElement("sodipodiNamedview", {
    pagecolor: "#ffffff",
    bordercolor: "#666666",
    borderopacity: 1,
    objecttolerance: 10,
    gridtolerance: 10,
    guidetolerance: 10,
    inkscapePageopacity: 0,
    inkscapePageshadow: 2,
    "inkscapeWindow-width": 640,
    "inkscapeWindow-height": 480,
    id: "namedview4"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g10",
    inkscapeGroupmode: "layer",
    inkscapeLabel: "ink_ext_XXXXXX",
    transform: "matrix(1.3333333,0,0,-1.3333333,0,206.18667)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g12",
    transform: "scale(0.1)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 10,1516.39 V 993.832 c 0,-11.031 8.9727,-20 20,-20 h 554.82 c 155.348,0 281.282,125.928 281.282,281.278 v 0 c 0,155.35 -125.934,281.28 -281.282,281.28 H 30 c -11.0273,0 -20,-8.97 -20,-20",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path14"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 105.816,1225.32 c -7.5855,-6.85 -17.4449,-9.84 -33.0387,-9.84 H 66.293 v 81.86 h 6.4843 c 15.5938,0 25.0625,-2.79 33.0387,-10.01 8.356,-7.44 13.368,-18.95 13.368,-30.81 0,-11.89 -5.012,-23.77 -13.368,-31.2 z m -28.2027,93 H 42.168 v -123.8 h 35.2539 c 18.7461,0 32.2891,4.42 44.1721,14.3 14.121,11.69 22.469,29.3 22.469,47.51 0,36.54 -27.293,61.99 -66.4497,61.99",
    style: {
      fill: "#231c1d",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path16"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 155.18,1194.52 h 24.14 v 123.8 h -24.14 v -123.8",
    style: {
      fill: "#231c1d",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path18"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 238.363,1270.81 c -14.492,5.37 -18.746,8.9 -18.746,15.59 0,7.8 7.582,13.72 17.988,13.72 7.239,0 13.18,-2.97 19.473,-10.03 l 12.637,16.55 c -10.387,9.08 -22.809,13.72 -36.375,13.72 -21.906,0 -38.613,-15.21 -38.613,-35.47 0,-17.05 7.781,-25.78 30.461,-33.94 9.449,-3.34 14.257,-5.56 16.687,-7.06 4.82,-3.14 7.242,-7.6 7.242,-12.8 0,-10.03 -7.976,-17.46 -18.754,-17.46 -11.508,0 -20.789,5.75 -26.347,16.5 l -15.602,-15.01 c 11.125,-16.33 24.484,-23.57 42.859,-23.57 25.094,0 42.7,16.68 42.7,40.64 0,19.68 -8.137,28.58 -35.61,38.62",
    style: {
      fill: "#231c1d",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 281.59,1256.33 c 0,-36.38 28.57,-64.59 65.34,-64.59 10.39,0 19.289,2.04 30.269,7.2 v 28.43 c -9.656,-9.66 -18.207,-13.55 -29.152,-13.55 -24.32,0 -41.578,17.63 -41.578,42.7 0,23.76 17.812,42.51 40.461,42.51 11.511,0 20.238,-4.11 30.269,-13.93 v 28.41 c -10.597,5.38 -19.312,7.6 -29.703,7.6 -36.578,0 -65.906,-28.78 -65.906,-64.78",
    style: {
      fill: "#231c1d",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path22"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 568.656,1235.17 -33.023,83.15 h -26.371 l 52.531,-126.98 h 12.996 l 53.481,126.98 h -26.18 l -33.434,-83.15",
    style: {
      fill: "#231c1d",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path24"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 639.18,1194.52 h 68.484 v 20.96 h -44.348 v 33.42 h 42.704 v 20.97 h -42.704 v 27.47 h 44.348 v 20.98 H 639.18 v -123.8",
    style: {
      fill: "#231c1d",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path26"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 754.832,1261.32 h -7.062 v 37.5 h 7.433 c 15.047,0 23.223,-6.3 23.223,-18.35 0,-12.45 -8.176,-19.15 -23.594,-19.15 z m 48.449,20.45 c 0,23.18 -15.976,36.55 -43.824,36.55 h -35.801 v -123.8 h 24.114 v 49.73 h 3.156 l 33.422,-49.73 h 29.691 l -38.976,52.16 c 18.195,3.7 28.218,16.13 28.218,35.09",
    style: {
      fill: "#231c1d",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path28"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 817.93,1310.34 h -0.45 v 2.85 h 0.473 c 1.285,0 1.961,-0.46 1.961,-1.4 0,-0.97 -0.684,-1.45 -1.984,-1.45 z m 4.593,1.48 c 0,2.18 -1.507,3.37 -4.14,3.37 h -3.5 v -10.91 h 2.597 v 4.23 l 3.055,-4.23 h 3.188 l -3.59,4.5 c 1.531,0.41 2.39,1.53 2.39,3.04",
    style: {
      fill: "#231c1d",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path30"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 818.867,1301.93 c -4.172,0 -7.582,3.48 -7.582,7.81 0,4.35 3.379,7.82 7.582,7.82 4.156,0 7.535,-3.55 7.535,-7.82 0,-4.29 -3.379,-7.81 -7.535,-7.81 z m 0.039,17.34 c -5.297,0 -9.508,-4.23 -9.508,-9.51 0,-5.29 4.258,-9.53 9.508,-9.53 5.164,0 9.399,4.29 9.399,9.53 0,5.21 -4.235,9.51 -9.399,9.51",
    style: {
      fill: "#231c1d",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path32"
  }), /*#__PURE__*/React.createElement("g", {
    id: "g34"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g36",
    clipPath: "url(#clipPath40)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g42",
    clipPath: "url(#clipPath46)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g48",
    clipPath: "url(#clipPath52)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 258.027,516.961 -282.34,1452.9 653.602,1993.26 1193.97,1057.32 258.027,516.961",
    style: {
      fill: "#e13f20",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path54"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 269.273,497.469 -271.09,1433.41 664.852,1973.78 1205.21,1037.84 269.273,497.469",
    style: {
      fill: "#e04020",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 280.523,477.992 -259.84,1413.93 676.098,1954.29 1216.46,1018.36 280.523,477.992",
    style: {
      fill: "#e14120",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path58"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 291.773,458.5 -248.59,1394.45 687.348,1934.81 1227.71,998.871 291.773,458.5",
    style: {
      fill: "#e14220",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path60"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 303.023,439.02 -237.34,1374.96 698.598,1915.32 1238.96,979.387 303.023,439.02",
    style: {
      fill: "#e2431f",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path62"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 314.273,419.539 -226.094,1355.48 709.848,1895.84 1250.21,959.902 314.273,419.539",
    style: {
      fill: "#e2431f",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path64"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 325.523,400.051 -214.844,1335.99 721.098,1876.36 1261.46,940.418 325.523,400.051",
    style: {
      fill: "#e3441f",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path66"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 336.77,380.57 -203.594,1316.51 732.348,1856.87 1272.71,920.934 336.77,380.57",
    style: {
      fill: "#e3451f",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path68"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 348.02,361.082 -192.344,1297.02 743.594,1837.39 1283.96,901.449 348.02,361.082",
    style: {
      fill: "#e3461f",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path70"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 359.27,341.602 -181.094,1277.54 754.844,1817.9 1295.21,881.965 359.27,341.602",
    style: {
      fill: "#e4471f",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path72"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 370.52,322.109 -169.848,1258.05 766.094,1798.42 1306.46,862.48 370.52,322.109",
    style: {
      fill: "#e4471f",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path74"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 381.77,302.629 -158.598,1238.57 777.344,1778.93 1317.71,842.996 381.77,302.629",
    style: {
      fill: "#e5481e",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path76"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 393.02,283.148 -147.348,1219.09 788.594,1759.45 1328.96,823.512 393.02,283.148",
    style: {
      fill: "#e5491e",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path78"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 404.266,263.66 -136.098,1199.6 799.84,1739.96 1340.21,804.027 404.266,263.66",
    style: {
      fill: "#e54a1e",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path80"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 415.516,244.18 -124.848,1180.12 811.09,1720.48 1351.46,784.543 415.516,244.18",
    style: {
      fill: "#e64b1e",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path82"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 426.766,224.691 -113.598,1160.63 822.34,1701 1362.7,765.059 426.766,224.691",
    style: {
      fill: "#e64b1e",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path84"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 438.016,205.211 -102.352,1141.15 833.59,1681.51 1373.95,745.574 438.016,205.211",
    style: {
      fill: "#e74c1d",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path86"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 449.266,185.719 -91.1016,1121.66 844.84,1662.03 1385.2,726.09 449.266,185.719",
    style: {
      fill: "#e74d1d",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path88"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 460.512,166.238 -79.8516,1102.18 856.09,1642.54 1396.45,706.605 460.512,166.238",
    style: {
      fill: "#e84e1d",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path90"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 471.762,146.75 -68.6016,1082.7 867.336,1623.06 1407.7,687.121 471.762,146.75",
    style: {
      fill: "#e94e1d",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path92"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 476.113,139.219 -64.2539,1075.16 871.688,1615.53 1412.05,679.586 476.113,139.219",
    style: {
      fill: "#e94f1d",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path94"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 480.461,131.691 -59.9023,1067.63 876.035,1608 1416.4,672.055 480.461,131.691",
    style: {
      fill: "#ea501c",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path96"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 484.809,124.16 -55.5547,1060.1 880.383,1600.46 1420.75,664.523 484.809,124.16",
    style: {
      fill: "#ea511c",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path98"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 489.156,116.629 -51.207,1052.57 884.734,1592.93 1425.1,656.988 489.156,116.629",
    style: {
      fill: "#ea521c",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path100"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 493.508,109.09 -46.8594,1045.03 889.082,1585.4 1429.45,649.457 493.508,109.09",
    style: {
      fill: "#ea531c",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path102"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 497.855,101.559 -42.5078,1037.5 893.43,1577.86 1433.79,641.926 497.855,101.559",
    style: {
      fill: "#ea541c",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path104"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 502.203,94.0313 -38.1602,1029.97 897.777,1570.33 1438.14,634.395 502.203,94.0313",
    style: {
      fill: "#ea551c",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path106"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 506.555,86.5 -33.8125,1022.43 902.129,1562.8 1442.49,626.859 506.555,86.5",
    style: {
      fill: "#ea561b",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path108"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 510.902,78.9609 -29.4609,1014.9 906.477,1555.27 1446.84,619.328 510.902,78.9609",
    style: {
      fill: "#ea571b",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path110"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 515.25,71.4297 -25.1133,1007.37 910.824,1547.73 1451.19,611.797 515.25,71.4297",
    style: {
      fill: "#eb581b",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path112"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 519.602,63.8984 -20.7656,999.84 915.176,1540.2 1455.54,604.266 519.602,63.8984",
    style: {
      fill: "#eb591b",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path114"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 523.949,56.3711 -16.418,992.305 919.523,1532.67 1459.89,596.73 523.949,56.3711",
    style: {
      fill: "#eb5a1b",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path116"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 528.297,48.832 -12.0664,984.773 923.871,1525.14 1464.24,589.199 528.297,48.832",
    style: {
      fill: "#eb5b1b",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path118"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 532.645,41.3008 -7.71875,977.242 928.223,1517.61 1468.59,581.668 532.645,41.3008",
    style: {
      fill: "#ec5d1a",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path120"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 536.996,33.7695 -3.37109,969.707 932.57,1510.07 1472.93,574.133 536.996,33.7695",
    style: {
      fill: "#ec5e1a",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path122"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 541.344,26.2383 0.980469,962.176 936.918,1502.54 1477.28,566.602 541.344,26.2383",
    style: {
      fill: "#ec5f1a",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path124"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 545.691,18.6992 5.32813,954.645 941.266,1495.01 1481.63,559.07 545.691,18.6992",
    style: {
      fill: "#ec601a",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path126"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 550.043,11.1719 9.67578,947.109 945.617,1487.48 1485.98,551.539 550.043,11.1719",
    style: {
      fill: "#ed611a",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path128"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 554.391,3.64063 14.0273,939.578 949.965,1479.95 1490.33,544 554.391,3.64063",
    style: {
      fill: "#ed6219",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path130"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 558.738,-3.89063 18.375,932.047 954.313,1472.41 1494.68,536.469 558.738,-3.89063",
    style: {
      fill: "#ec6319",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path132"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 563.09,-11.418 22.7227,924.516 958.66,1464.88 1499.03,528.941 563.09,-11.418",
    style: {
      fill: "#ec6419",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path134"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 567.438,-18.9609 27.0703,916.98 963.012,1457.35 1503.38,521.41 567.438,-18.9609",
    style: {
      fill: "#ed6519",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path136"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 571.785,-26.4883 31.4219,909.449 967.359,1449.82 1507.72,513.879 571.785,-26.4883",
    style: {
      fill: "#ed6619",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path138"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 576.133,-34.0195 35.7695,901.918 971.711,1442.28 1512.07,506.34 576.133,-34.0195",
    style: {
      fill: "#ed6818",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path140"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 580.484,-41.5508 40.1172,894.387 976.059,1434.75 1516.42,498.809 580.484,-41.5508",
    style: {
      fill: "#ee6918",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path142"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 584.832,-49.0898 44.4688,886.852 980.406,1427.22 1520.77,491.281 584.832,-49.0898",
    style: {
      fill: "#ee6918",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path144"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 589.18,-56.6211 48.8164,879.32 984.754,1419.68 1525.12,483.75 589.18,-56.6211",
    style: {
      fill: "#ee6a18",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path146"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 593.531,-64.1484 53.1641,871.789 989.105,1412.15 1529.47,476.211 593.531,-64.1484",
    style: {
      fill: "#ee6c18",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path148"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 597.879,-71.6797 57.5156,864.254 993.453,1404.62 1533.82,468.68 597.879,-71.6797",
    style: {
      fill: "#ef6d17",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path150"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 602.227,-79.2188 61.8633,856.723 997.801,1397.09 1538.17,461.148 602.227,-79.2188",
    style: {
      fill: "#ef6e17",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path152"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 606.574,-86.75 66.2109,849.191 1002.15,1389.55 1542.52,453.621 606.574,-86.75",
    style: {
      fill: "#ef6f17",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path154"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 610.926,-94.2813 70.5586,841.656 1006.5,1382.02 1546.86,446.082 610.926,-94.2813",
    style: {
      fill: "#ef7017",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path156"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 615.273,-101.809 74.9102,834.125 1010.85,1374.49 1551.21,438.551 615.273,-101.809",
    style: {
      fill: "#f07017",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path158"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 619.621,-109.352 79.2578,826.594 1015.2,1366.96 1555.56,431.02 619.621,-109.352",
    style: {
      fill: "#f07116",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path160"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 623.973,-116.879 83.6055,819.063 1019.55,1359.43 1559.91,423.488 623.973,-116.879",
    style: {
      fill: "#f07216",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path162"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 628.32,-124.41 87.957,811.527 1023.89,1351.89 1564.26,415.949 628.32,-124.41",
    style: {
      fill: "#f07316",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path164"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 632.668,-131.941 92.3047,803.996 1028.24,1344.36 1568.61,408.422 632.668,-131.941",
    style: {
      fill: "#f17416",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path166"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 637.02,-139.48 96.6523,796.465 1032.59,1336.83 1572.96,400.891 637.02,-139.48",
    style: {
      fill: "#f17616",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path168"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 641.367,-147.008 101.004,788.934 1036.94,1329.3 1577.31,393.359 641.367,-147.008",
    style: {
      fill: "#f17615",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path170"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 645.715,-154.539 105.352,781.398 1041.29,1321.77 1581.65,385.82 645.715,-154.539",
    style: {
      fill: "#f17815",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path172"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 650.063,-162.07 109.699,773.867 1045.64,1314.23 1586,378.289 650.063,-162.07",
    style: {
      fill: "#f27915",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path174"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 654.414,-169.602 114.047,766.336 1049.99,1306.7 1590.35,370.762 654.414,-169.602",
    style: {
      fill: "#f27915",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path176"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 658.762,-177.141 118.398,758.801 1054.34,1299.17 1594.7,363.23 658.762,-177.141",
    style: {
      fill: "#f27b15",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path178"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 663.109,-184.668 122.746,751.27 1058.68,1291.64 1599.05,355.699 663.109,-184.668",
    style: {
      fill: "#f47c14",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path180"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 667.461,-192.199 127.094,743.738 1063.03,1284.1 1603.4,348.16 667.461,-192.199",
    style: {
      fill: "#f47e14",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path182"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 671.809,-199.73 131.445,736.207 1067.38,1276.57 1607.75,340.629 671.809,-199.73",
    style: {
      fill: "#f48014",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path184"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 676.156,-207.27 135.793,728.672 1071.73,1269.04 1612.1,333.102 676.156,-207.27",
    style: {
      fill: "#f38113",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path186"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 680.508,-214.801 140.141,721.141 1076.08,1261.5 1616.45,325.57 680.508,-214.801",
    style: {
      fill: "#f48213",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path188"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 684.855,-222.328 144.488,713.609 1080.43,1253.97 1620.79,318.031 684.855,-222.328",
    style: {
      fill: "#f48413",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path190"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 689.203,-229.859 148.84,706.074 1084.78,1246.44 1625.14,310.5 689.203,-229.859",
    style: {
      fill: "#f48513",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path192"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 693.551,-237.398 153.188,698.543 1089.13,1238.91 1629.49,302.969 693.551,-237.398",
    style: {
      fill: "#f48613",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path194"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 697.902,-244.93 157.535,691.012 1093.48,1231.38 1633.84,295.441 697.902,-244.93",
    style: {
      fill: "#f58714",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path196"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 702.25,-252.461 161.887,683.48 1097.82,1223.84 1638.19,287.898 702.25,-252.461",
    style: {
      fill: "#f58814",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path198"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 706.598,-259.988 166.234,675.945 1102.17,1216.31 1642.54,280.371 706.598,-259.988",
    style: {
      fill: "#f58914",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path200"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 710.949,-267.531 170.582,668.414 1106.52,1208.78 1646.89,272.84 710.949,-267.531",
    style: {
      fill: "#f58a15",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path202"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 715.297,-275.059 174.934,660.883 1110.87,1201.25 1651.24,265.309 715.297,-275.059",
    style: {
      fill: "#f68b15",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path204"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 719.645,-282.59 179.281,653.348 1115.22,1193.71 1655.58,257.77 719.645,-282.59",
    style: {
      fill: "#f68c15",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path206"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 723.992,-290.121 183.629,645.816 1119.57,1186.18 1659.93,250.238 723.992,-290.121",
    style: {
      fill: "#f68e15",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path208"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 728.344,-297.648 187.977,638.285 1123.92,1178.65 1664.28,242.711 728.344,-297.648",
    style: {
      fill: "#f68f14",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path210"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 732.691,-305.191 192.328,630.754 1128.27,1171.12 1668.63,235.18 732.691,-305.191",
    style: {
      fill: "#f79014",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path212"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 737.039,-312.719 196.676,623.219 1132.61,1163.59 1672.98,227.648 737.039,-312.719",
    style: {
      fill: "#f69114",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path214"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 741.391,-320.25 201.023,615.688 1136.96,1156.05 1677.33,220.109 741.391,-320.25",
    style: {
      fill: "#f79314",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path216"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 745.738,-327.781 205.371,608.156 1141.31,1148.52 1681.68,212.582 745.738,-327.781",
    style: {
      fill: "#f79414",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path218"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 750.086,-335.32 209.723,600.625 1145.66,1140.99 1686.03,205.051 750.086,-335.32",
    style: {
      fill: "#f79514",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path220"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 754.438,-342.852 214.07,593.09 1150.01,1133.46 1690.37,197.52 754.438,-342.852",
    style: {
      fill: "#f79614",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path222"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "g224"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g226",
    clipPath: "url(#clipPath230)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g232",
    transform: "matrix(140.2,0,0,140.2,380.9,1185.9)"
  }, /*#__PURE__*/React.createElement("image", {
    width: 1,
    height: 1,
    style: {
      imageRendering: "optimizeSpeed"
    },
    preserveAspectRatio: "none",
    transform: "matrix(1,0,0,-1,0,1)",
    xlinkHref: "data:image/png;base64,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",
    id: "image234"
  })))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDiscover);
export default __webpack_public_path__ + "static/media/discover.617f79e1c6d2a4bf24fe09f351ad74ac.svg";
export { ForwardRef as ReactComponent };